import { schoolNcesIdSchema } from "@nimble/candidate-api/types";
import type { UserId } from "@nimble/datamodel/types/userId";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getSavedSchoolQueryKey } from "@/hooks/data/use-saved-school";
import {
  createSavedSchool,
  deleteSavedSchool,
} from "@/lib/api-clients/candidate-api-client";

type SaveSchoolMutationVariables = {
  ncesId: string;
  save: boolean;
};

export default function useSaveSchoolMutation(userId: UserId) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ ncesId, save }: SaveSchoolMutationVariables) => {
      const schoolNcesId = schoolNcesIdSchema.parse(ncesId);

      if (save) {
        return createSavedSchool(userId, schoolNcesId);
      } else {
        return deleteSavedSchool(userId, schoolNcesId);
      }
    },
    onSuccess: (_data, { ncesId }) => {
      queryClient.invalidateQueries({
        queryKey: getSavedSchoolQueryKey(userId, ncesId),
      });
      queryClient.invalidateQueries({
        queryKey: ["user-schools-search"],
      });
    },
  });
}
